import style from './style.scss';
import React, { Component } from 'react';
import VideoPopup from './videoPopup';
import CustomSwal from '../popupContents/CustomSwal';
import { API, BASE_PATH_URL } from '../API/index.js';
import { Event } from '../../utils/events';
import { route } from 'preact-router';
import ReactDOM from 'react-dom';
import ReactHtmlParser from 'react-html-parser';
import PDFViewer from '../PDFViewer/index.js';
import PDFJSBackend from '../../backend/pdfjs';

class ArticlePopup extends Component {
	constructor(props) {
		super();
		const BASE_PATH = props.apisWorking ? 'https://dev365.gdpventure.com' : '';
		this.state = {
			basePath        : BASE_PATH,
			article         : props.article,
			apisWorking     : props.apisWorking,
			type            : props.type,
			recommendations : []
		};
		Event(
			'Go to Article Page',
			window.location.origin + '/article?title=' + this.state.article.field_url,
			'Article Page Route'
		);
	}

	getMobileOperatingSystem() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return 'Windows Phone';
		}
		if (/android/i.test(userAgent)) {
			return 'Android';
		}
		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return 'iOS';
		}
		return 'unknown';
	}

	modalFire = (article, apisWorking) => {
		const popupContent = (
			<VideoPopup basePath={this.state.basePath} videoURL={this.state.article.field_article_video_url} />
		);

		if (this.getMobileOperatingSystem() != 'iOS') {
			if (!window.matchMedia('(max-width: 900px)').matches) {
				const FullScreenDialog = CustomSwal.getCustomSwal();
				FullScreenDialog.fire({
					html : popupContent
				}).then(function() {
					CustomSwal.firePopUpAgain(article, apisWorking);
				});
			}
			else {
				CustomSwal.firePopUpVideo(popupContent);
			}
		}
		else {
			this.iOSplay();
		}
	};

	htmlFormattedData(data) {
		var decoded_body = data.replace(
			/<img([^>]*)\ssrc=(['"])(\/[^\2*([^\2\s<]+)\2/gi,
			'<img$1 src=$2' + BASE_PATH_URL + '$3$2'
		);
		return ReactHtmlParser(decoded_body);
	}

	formattedData(data) {
		if (data) {
			const parser = new DOMParser();
			return parser.parseFromString(`<!doctype html><body>${data}`, 'text/html').body.textContent;
		}
		return '';
	}

	divStyle(imgUrl) {
		let divStyle = {
			backgroundImage : 'url(' + imgUrl + ')'
		};
		return divStyle;
	}

	onClickRecommendedArticle = (data) => {
		if (this.state.type == 'page') {
			route('/article?title=' + 'Yuzu-Music-Concert-Road-Show');
		}
		else {
			if (window.matchMedia('(max-width: 900px)').matches) {
				this.closeModal();
			}
			CustomSwal.firePopUpAgain(data, this.state.apisWorking);
		}
	};

	closeModal = () => {
		document.body.classList.remove('open_modal');
		document.getElementById('app').classList.remove('open_modal_app');
		document.getElementById('user_modal').removeChild(document.getElementById('modal_content'));
	};

	iOSplay = () => {
		var mediaElement = document.getElementById('videoEle');
		mediaElement.style.display = 'block';
		mediaElement.webkitEnterFullscreen();
		mediaElement.play();
	};

	swapDiv = () => {
		var parentNode1 = document.getElementById('pNode');
		parentNode1.innerHTML = '';
		var vNode = (
			<video
				id="videoEle"
				style="width: 0vw;margin: 0vw;height:0vH;object-fit: cover;display:none"
				autoplay="false"
				controls
			>
				<source src={this.state.basePath + this.state.article.field_article_video_url} type="video/mp4" />
			</video>
		);
		setTimeout(() => {
			ReactDOM.render(vNode, document.getElementById('pNode'));
			document.getElementById('videoEle').addEventListener('webkitendfullscreen', this.swapDiv);
		}, 1000);
	};

	componentDidMount() {
		document.getElementsByClassName(style.headerImg)[0].style.height =
			9 / 16 * document.getElementsByClassName(style.headerImg)[0].clientWidth + 'px';
		document.getElementsByClassName(style.newsImgContent)[0].style.height =
			9 / 16 * document.getElementsByClassName(style.headerImg)[0].clientWidth + 'px';

		if (document.getElementById('videoEle')) {
			document.getElementById('videoEle').addEventListener('webkitendfullscreen', this.swapDiv);
		}

		if (this.getMobileOperatingSystem() === 'iOS') {
			if (document.getElementById(style.myBtn1)) {
				document.getElementById(style.myBtn1).style.transform = 'translate(-50%, -50%)';
			}
		}

		document.getElementById('news-article').onscroll = function() {
			var winScroll = document.getElementById('news-article').scrollTop;
			var height = document.getElementsByClassName(style.newsPopUp)[0].clientHeight;
			var screenHeight = window.innerHeight;
			var scrolled = winScroll / (height - screenHeight) * 100;
			document.getElementById('myBar').style.width = scrolled + '%';
		};

		API.getrecommendationData('/recommendation', {
			count : 4,
			index : parseInt(this.state.article.field_connect_id)
		})
			.then((res) => {
				if (res) {
					this.setState({
						recommendations : res.DATA,
						apisWorking     : true
					});
				}
			})
			.catch((error) => console.error(error));

		// function myFunction() {
		// 	var winScroll = document.getElementById('news-article').scrollTop;
		// 	var height = document.getElementsByClassName(style.newsPopUp)[0].clientHeight;
		// 	var screenHeight = screen.height;
		// 	var scrolled = winScroll / (height - screenHeight) * 100;
		// 	document.getElementById('myBar').style.width = scrolled + '%';
		// }
	}

	componentWillReceiveProps(nextProps) {
		window.scrollTo(0, 0);
		var loc = window.location.href;
		var title = loc.split('?')[1].split('&')[0].split('=')[1];
		API.getArticleByArticleURL('/' + title)
			.then((res) => {
				if (res && res.length > 0) {
					this.setState({
						article     : res[0],
						apisWorking : true
					});
				}
			})
			.catch((error) => console.error(error));
	}

	renderModal() {
		return (
			<Modal open={open} onClose={this.onCloseModal} little>
				<h2>Simple centered modal</h2>
			</Modal>
		);
	}

	togglePopup() {
		this.setState({
			showPopup : !this.state.showPopup
		});
	}

	renderPDF() {
		const { article } = this.state;
		if (Object.keys(article).length > 0 && article.field_attachments != '' && 'field_attachments' in article) {
			return (
				<div style="justify-content:center;margin: auto;display: flex;flex-direction: column;">
					<PDFViewer
						backend={PDFJSBackend}
						src={'https://cors-anywhere.herokuapp.com/' + BASE_PATH_URL + article.field_attachments}
					/>
					<button
						class={style.downloadPDF}
						onClick={() => {
							window.open(BASE_PATH_URL + article.field_attachments, '_blank');
						}}
					>
						DOWNLOAD REPORT
					</button>
				</div>
			);
		}
	}

	render() {
		const parser = new DOMParser();
		let facebookSharingBaseUrl =
			'https://www.facebook.com/sharer/sharer.php?u=' +
			encodeURIComponent(window.location.origin + '/#/article' + '?title=');
		let twitterSharingBaseUrl =
			'https://twitter.com/intent/tweet?url=' +
			encodeURIComponent(window.location.origin + '/#/article' + '?title=');
		let mailSharingBaseUrl =
			'mailto:someone@example.com?Subject=Hello%20again&body=' +
			encodeURIComponent(window.location.origin + '/#/article' + '?title=');

		let shareLink = window.location.origin + '/#/article' + '?title=' + 'Endeus-Food-Story-Competition';
		let shareURL = encodeURIComponent(shareLink);
		const fbShareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareURL;

		return (
			<div id="news-article" style="height: 100vh;min-height:100vH; width: 100vw; overflow:scroll;">
				<div>
					{this.state.type == 'page' ? null : (
						<div class={style.progressContainer}>
							<div class={style.progressBar} id="myBar" />
						</div>
					)}
					<div class={style.newsPopUp}>
						<div
							class={style.newsSocialConnections}
							style={this.props.socialdisplay ? 'display:none' : null}
						>
							<a
								href={twitterSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
								target="_blank"
							>
								<img src="/assets/images/twitter.svg" />
							</a>
							<a
								href={facebookSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
								target="_blank"
							>
								<img src="/assets/images/facebook.svg" />
							</a>
							<a
								href={mailSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
								target="_blank"
							>
								<img src="/assets/images/news-overlay/mail_white_news.png" />
							</a>
						</div>
						{/* <button id='custom_close'>×</button> */}
						{/* <button
							type="button"
							// class='swal2-close close-button-class custom_close'
							class="custom_close swal2-close"
							// aria-label='Close this dialog'
							style="top: 4% !important;position:fixed;right: 3%"
							onClick={this.closeModal}
						>
							×
						</button> */}
						<img
							src="/assets/images/closeButtonArticle.png"
							class={style.closeButtonForPopup}
							onClick={this.closeModal}
						/>
						<div onClick={this.closeModal} class={style.crossLeaderDesktopButton}>
							<div />
							<div />
							<div />
						</div>
						<div class={style.newsImgContent}>
							{this.state.article.field_article_video_url === undefined ||
							('field_article_video_url' in this.state.article &&
								this.state.article.field_article_video_url.length === 0) ? (
								<img
									class={style.headerImg}
									src={this.state.basePath + this.state.article.field_article_image}
								/>
							) : (
								<div
									// id='videoDiv'
									style={this
										.divStyle
										// this.state.basePath + this.state.article.field_tile_image
										()
									// backgroundImage: 'url(' + imgUrl + ')
									// "background-image:" +
									// this.state.basePath +
									// this.state.article.field_tile_image
									}
								>
									{/* <video
                    loop='true'
                    src={this.state.article.field_article_video_url}
                    muted
                    autoPlay
                    poster='/assets/images/backgroundform2.png'
                    muted
                    loop='true'
                    poster
                    controls
                    playsinline
                    id='video'
                  /> */}

									{this.getMobileOperatingSystem() === 'iOS' ? (
										<div id="pNode">
											<video
												id="videoEle"
												style="width: 0vw;margin: 0vw;height:0vH;object-fit: cover;display:none"
												// autoplay="false"
												// playsinline
												controls
											>
												<source
													src={
														this.state.basePath + this.state.article.field_article_video_url
													}
													type="video/mp4"
												/>
											</video>
										</div>
									) : null}

									<div style="position: relative;">
										<div id="img_overlay_popup" />
										<img
											class={style.headerImg}
											id="imgDiv"
											src={this.state.basePath + this.state.article.field_tile_image}
										/>
										<button
											class="new-button"
											id={style.myBtn1}
											onClick={() => this.modalFire(this.state.article, this.state.apisWorking)}
										>
											Play
										</button>
									</div>
								</div>
							)}
						</div>
						<div class={style.newsMainContent}>
							<h1 class={style.headerTitle}>
								{this.formattedData(this.state.article.field_article_heading)}
							</h1>
							<div class={style.headerSecondaryTitle}>
								{this.formattedData(this.state.article.field_subtitle)}
							</div>
							{this.state.article.field_authored_by && (
								<div class={style.headerAuthorTitle}>
									{
										parser.parseFromString(
											`<!doctype html><body>${'By ' + this.state.article.field_authored_by}`,
											'text/html'
										).body.textContent
									}
								</div>
							)}
							<div
								class={style.importedHtml}
								// dangerouslySetInnerHTML={{
								// 	__html : this.state.article.field_description
								// }}
							>
								{this.htmlFormattedData(this.state.article.field_description)}
							</div>
							<div
								class={style.share}
								// style={this.props.socialdisplay ? 'display:none' : null}
								// 'margin-bottom: 0;font-size: 1rem;font-family: "Gotham-Black",Arial, Helvetica, sans-serif;margin-top: 2rem;'}
							>
								{' '}
								Share{' '}
							</div>
							<div
								class={style.newsSocialConnectionsMobile}
								style={this.props.socialdisplay ? 'display:none' : null}
							>
								<a
									href={twitterSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
									target="_blank"
								>
									<img src="/assets/images/twitter.svg" />
								</a>
								<a
									href={facebookSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
									target="_blank"
								>
									<img src="/assets/images/facebook.svg" />
								</a>
								<a
									href={mailSharingBaseUrl + encodeURIComponent(this.state.article.field_url)}
									target="_blank"
								>
									<img src="/assets/images/news-overlay/mail_white_news.png" />
								</a>
							</div>
							<div>{this.renderPDF()}</div>
							<p class={style.newsRecommended}>Recommended for you</p>
							<div class={style.overlayNewsBoxes} id="overlay-news-boxes">
								{this.state.recommendations.length > 0 ? (
									this.state.recommendations.map((data) => (
										<div
											class={style.overlayBlockDiv}
											onClick={() => this.onClickRecommendedArticle(data)
											// CustomSwal.firePopUpAgain(
											//   data,
											//   this.state.apisWorking
											// )
											}
										>
											<img
												src={this.state.basePath + data.field_tile_image}
												id="overlay-block-news"
											/>
											<p>{this.formattedData(data.field_article_heading)}</p>
										</div>
									))
								) : null}
							</div>
						</div>
						<div
							class={style.newsCloseModal}
							data-aos="fade-left"
							data-aos-offset="100"
							data-aos-delay="200"
							data-aos-duration="500"
							data-aos-easing="ease-in-out-quad"
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default ArticlePopup;



// WEBPACK FOOTER //
// ./components/popupContents/articlePopup.js